import * as React from "react";
import { Edit, SimpleForm, TextInput } from "react-admin";
import AuthorizedCheck from "../../components/Authorized/AuthorizedCheck";

const CategoryEditTitle = ({ record }: any) => {
  return <span>Category: {record ? `"${record.name}"` : ""}</span>;
};

const CategoryEdit = (props) => {
  return (
    <AuthorizedCheck>
      <Edit {...props} title={<CategoryEditTitle />}>
        <SimpleForm>
          <TextInput source="name" />
        </SimpleForm>
      </Edit>
    </AuthorizedCheck>
  );
};

export default CategoryEdit;
